import { useDigitalTrapsStore } from '@features/regional-overview/digital-traps/digital-traps.zustand';
import type { TrapGroup } from '@features/regional-overview/digital-traps/domain';
import { useMemo, useState } from 'react';
import { useNetworkManagementStore } from '../../network-management.zustand';
import { createCustomOption } from './network-select.utils';

export const useNetworkSelect = () => {
  const { selectedPestEppoCode } = useNetworkManagementStore();
  const allTrapGroups = useDigitalTrapsStore(state => state.allTrapGroups);

  const [items, setItems] = useState<string[]>([]);

  const options: TrapGroup[] = useMemo(() => {
    const groups = allTrapGroups?.filter(group => group.pestEppoCode === selectedPestEppoCode);

    const addedItems = items.map(item => createCustomOption(item));
    return [...groups, ...addedItems];
  }, [allTrapGroups, items, selectedPestEppoCode]);

  return {
    options,
    setItems
  };
};
